import { HttpClient } from '../utils/httpClient';
import { API_CONFIG } from './api';

class AuthService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient(API_CONFIG.baseURL);
  }

  async verifyAccessCode(code: string): Promise<{ valid: boolean; status: string }> {
    return this.httpClient.request<{ valid: boolean; status: string }>('/api/v1/code/verify', {
      method: 'POST',
      body: JSON.stringify({ code }),
    });
  }
}

export const authService = new AuthService();